const orderSk = {
    "total": "Celkom",
    "order_successfully_placed": "Objednávka zadaná",
    "empty_cart": "Váš košík je momentálne prázdny",
    "place_order": "Objednať",
    "i_order": "Objednať",
    "order_confirmation": "Potvrdenie objednávky",
    "order_confirmation_msg_raw": "Odoslaním objednávky súhlasíte s našimi podmienkami používania a zásadami ochrany osobných údajov, ktoré nájdete v <a href=\":link\" class=\"generated-link\" target=\"_blank\">odkaze nižšie</a>.",
    "status_PLACED": "Umiestnené",
    "status_ACCEPTED": "Prijaté",
    "status_SERVED": "Podávané",
    "status_PAID": "Platené",
    "empty_pending_orders": "Momentálne nemáte žiadne čakajúce objednávky",
    "overview": "Prehľad objednávky",
    "note": "Poznámka",
    "items": "Položky",
    "review_order": "Prehľad"
};

export default orderSk;
